import React, { useState } from 'react'
import { connect } from 'react-redux'
import { PageHeader, Menu, Dropdown, Button, Tag, Result } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

import {getStudentreports} from '../actions/studentreport';

const Reports = (props) => {
    const [reports, setreports] = useState({})
    
    const get_rows = (id, arrays) =>{
         return arrays[id]
    }
  
    let arr_reports = []
    Object.keys(props.reports).forEach(schoolid=>{
        let sessions = props.reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let arr = {}
            let sch = get_rows(schoolid, props.schools)
            let ses = get_rows(sessionid, props.sessions)
            arr['schoolname'] = sch.abbrv || ''
            arr['sessionname'] = ses.name || ''
            arr['schooldata'] = sch
            arr['sessiondata'] = ses
            arr_reports.push(arr)              
        })
    })
    const loadResult = (d) =>{
        let session = d
            let params = {
            data:JSON.stringify(
            {
                  'sessionid':session,
                  'studentid' : props.mid
              }),
              cat:'selectreportmain',
              table:'studentscore',
              narration:'get fees'
            }
            props.getStudentreports(params)

    }
    const menu = (
        <Menu>
            {
                arr_reports.map((prop, index)=>{
                    return <Menu.Item 
                        key={index} 
                        onClick={()=>loadResult(prop)}
                    >
                      {`${prop.schoolname} ${prop.sessionname}`}
                  </Menu.Item>
                })
            }
        </Menu>
      );

    

    const DropdownMenu = () => (
        <Dropdown key="more" overlay={menu}>
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select Fees
          </Button>
        </Dropdown>
    );


    return (
        <div>
            <PageHeader
                title="Fees"
                className="site-page-header no-print"
                subTitle="Student Report Card"
                tags={<Tag color="blue">Active</Tag>}
                extra={[
                    <DropdownMenu key="more" />,
                ]}
                avatar={{ src: 'https://avatars1.githubusercontent.com/u/8186664?s=460&v=4' }}    
            ></PageHeader>
            <Result
                    status="403"
                    title="403"
                    subTitle="Sorry, you are not authorized to access this page."
                    extra={<Button type="primary">Back Home</Button>}
            />

            
        </div>
    )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer.reports,
    schools:state.reportReducer.schools,
    claszs:state.reportReducer.claszs,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getStudentreports
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
